<script setup>
import {defineProps, defineEmits} from "vue";

defineProps({
    show: Boolean,
    loading: Boolean,
    disabled: Boolean,
    error: Boolean,
    block: Boolean,
})

const emit = defineEmits(["press"]);

function press() {
    emit('press');
}
</script>

<template>
    <w-btn
        v-if="show"
        :color="error ? 'red' : 'grey'"
        :loading="loading"
        :disabled="disabled"
        :text="$t('common.deactivate')"
        :icon="error ? 'mdi-alert' : 'mdi-power-plug-off'"
        @press="press"
    />
</template>

<style scoped>

</style>